import landing from '@/locales/sv/landing'
import promotions from '@/locales/sv/promotions'
import resultOrder from '@/locales/sv/result-order'
import invoice from '@/locales/sv/invoice'
import invoiceMcw from '@/locales/sv/invoice-mcw'
import currency from '@/locales/sv/currency'
import genericError from '@/locales/sv/generic-error'

export default {
  landing,
  resultOrder,
  invoice,
  currency,
  promotions,
  invoiceMcw,
  genericError
}
